import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    static targets = [
        'content',
        'title'
    ]
    connect() {

    }
    open(content, title) {
        this.element.setAttribute('data-open', 'true');
        document.body.setAttribute('data-popin', 'open');

        this.addContentInPopin(content, title);
    }
    close() {
        this.element.setAttribute('data-open', 'false');
        document.body.removeAttribute('data-popin');

        if (this.contentTarget) {
            this.contentTarget.innerHTML = '';
        }
    }

    addContentInPopin(content, title) {
        if (this.contentTarget) {
            const iframe = document.createElement('iframe');
            iframe.src = content;
            iframe.allowfullscreen = true;
            iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";

            this.contentTarget.innerHTML = '';
            this.contentTarget.appendChild(iframe);
        }

        if (title) {
            this.titleTarget.innerHTML = title;
        }
    }
}
